import React, { memo } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ChevronRight, CalendarIcon, Clock, Users, Wine, UtensilsCrossed, Check } from 'lucide-react';
export function RestaurantPage() {
  return <div className="min-h-screen bg-white" data-id="element-1309">
      {/* Header */}
      <Header variant="light" data-id="element-1310" />

      {/* Hero Section */}
      <section className="relative py-32 px-8 overflow-hidden" data-id="element-1311">
        <div className="absolute inset-0 z-0" style={{
        backgroundImage: 'url(https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/12/Restaurant-Cuvee.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }} data-id="element-1312" />
        <div className="absolute inset-0 bg-black/50 z-10" data-id="element-1313" />

        {/* Content */}
        <div className="max-w-4xl mx-auto text-center relative z-20 px-6 sm:px-8 h-full flex flex-col justify-center py-20" data-id="element-1314">
          <div className="w-16 h-0.5 bg-brand-pink mx-auto mb-6" data-id="element-1315" />
          <div className="text-brand-pink text-xs tracking-[0.4em] font-light uppercase mb-4" data-id="element-1316">
            Dining
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif text-white mb-6 leading-tight" data-id="element-1317">
            Restaurant Cuvee
          </h1>
          <p className="text-xl text-white mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-1318">
            Breakfast | 8.30am - 11.00am
            <br data-id="element-1319" />
            Lunch | 12.00pm - 3.00pm
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-1320">
            <button className="inline-flex items-center gap-2 bg-brand-pink text-white px-8 py-3 hover:bg-brand-pink/90 transition-colors font-medium rounded-none group" data-id="element-1321">
              <UtensilsCrossed size={18} data-id="element-1322" />
              View Menu
              <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-1323" />
            </button>
            <a href="#restaurant-booking" onClick={e => {
            e.preventDefault();
            document.getElementById('restaurant-booking')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} className="inline-flex items-center gap-2 px-8 py-3 border-2 border-white text-white hover:bg-white hover:text-brand-grey transition-colors font-medium rounded-none group" data-id="element-1324">
              <CalendarIcon size={18} data-id="element-1325" />
              Book Online
              <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-1326" />
            </a>
          </div>
        </div>
      </section>

      {/* Introduction Section */}
      <section className="bg-white py-20 px-8" data-id="element-1327">
        <div className="max-w-7xl mx-auto" data-id="element-1328">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-1329">
            {/* Content */}
            <div className="space-y-6 order-1" data-id="element-1330">
              <div className="space-y-3" data-id="element-1331">
                <div className="w-12 h-0.5 bg-brand-pink" data-id="element-1332"></div>
                <div className="text-brand-pink text-xs tracking-[0.3em] font-light uppercase" data-id="element-1333">
                  Welcome
                </div>
                <h2 className="text-5xl font-serif text-gray-900 leading-tight" data-id="element-1334">
                  A Blend of Delights{' '}
                </h2>
              </div>
              <div className="space-y-4" data-id="element-1335">
                <p className="text-gray-600 text-lg leading-relaxed" data-id="element-1336">
                  Located within the beautiful sandstone walls of Peterson
                  House, at the "Gateway" to the Hunter Valley Wineries,
                  Restaurant Cuvée features beautiful exposed aged timber
                  trusses with spectacular views overlooking our stunning
                  vineyards.
                </p>
                <p className="text-gray-600 text-lg leading-relaxed" data-id="element-1337">
                  Renowned for our famous Bubbly Breakfast, Restaurant Cuvée is
                  one of the best restaurants in the Hunter Valley. The perfect
                  spot to start your day, from a quick bite between tastings, to
                  a long, leisurely lunch, our menu is designed to provide
                  something for all guests.
                </p>
                <p className="text-gray-500 text-sm leading-relaxed pl-4 border-l-2 border-pink-200 italic" data-id="element-1338">
                  "In wine we refer to Cuvée as being a blend of different
                  grapes, or grapes from a different vintage. In food we can
                  also refer to Cuvée as the blend of old with new; sweet with
                  sour; smooth with crisp."
                </p>
                <p className="text-gray-500 text-sm leading-relaxed" data-id="element-1339">
                  A surcharge of 10% applies on Sundays and a surcharge of 15%
                  applies on Public Holidays
                </p>
              </div>
            </div>

            {/* Image */}
            <div className="relative aspect-[4/3] overflow-hidden rounded border-8 border-gray-100 shadow-xl bg-gray-300 order-2" data-id="element-1340">
              <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/11/Peterson-House-Restaurant-Image.jpg" alt="Restaurant Cuvee interior" className="w-full h-full object-cover" data-id="element-1341" />
            </div>
          </div>

          {/* Buttons Below Grid - Centered */}
          <div className="mt-12 flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-1342">
            <a href="#restaurant-menus" className="inline-flex items-center gap-2 bg-brand-grey text-white px-8 py-3 hover:bg-neutral-700 transition-colors font-medium rounded-none group w-full sm:w-auto" data-id="element-1343">
              <UtensilsCrossed size={18} data-id="element-1344" />
              View Menus
              <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-1345" />
            </a>
            <button className="inline-flex items-center gap-2 border-2 border-brand-grey text-brand-grey px-8 py-3 hover:bg-brand-grey hover:text-white transition-colors font-medium rounded-none group w-full sm:w-auto" data-id="element-1346">
              Gift Voucher
              <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-1347" />
            </button>
          </div>

          {/* Restaurant Booking Widget */}
          <div id="restaurant-booking" className="mt-16" data-id="element-1348">
            <iframe src="https://bookings.nowbookit.com/?accountid=72e321b2-4563-4ea2-98b7-ddb19c803f53&venueid=1301&theme=outlined-light&colors=hex,000000,ff80ab" className="w-full border-0" style={{
            minHeight: '600px'
          }} data-id="element-1349"></iframe>
            <script src="https://plugins.nowbookit.com/iframe-resizer-build/bundle.js" data-id="element-1350"></script>
          </div>

          {/* Menu Cards Section */}
          <div id="restaurant-menus" className="mt-20" data-id="element-1351">
            {/* Section Header */}
            <div className="text-center mb-12" data-id="element-1352">
              <div className="w-16 h-0.5 bg-brand-pink mx-auto mb-6" data-id="element-1353" />
              <div className="text-brand-pink text-xs tracking-[0.4em] font-light uppercase mb-4" data-id="element-1354">
                Our Menus
              </div>
              <h2 className="font-heading text-4xl lg:text-5xl text-neutral-900 mb-6 leading-tight" data-id="element-1355">
                Explore Our Dining Options
              </h2>
              <p className="text-lg text-neutral-600 max-w-3xl mx-auto leading-relaxed" data-id="element-1356">
                Choose from our selection of carefully crafted menus
              </p>
            </div>

            {/* Menu Buttons - Grouped Layout */}
            <div className="max-w-4xl mx-auto space-y-8" data-id="element-1357">
              {/* Breakfast Group */}
              <div className="space-y-3" data-id="element-1358">
                <h3 className="text-sm font-medium text-neutral-500 uppercase tracking-wider mb-3" data-id="element-1359">
                  Breakfast
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-1360">
                  <a href="#" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between gap-4 bg-white border-2 border-neutral-200 text-neutral-900 px-6 py-6 hover:border-brand-pink hover:bg-brand-pink/5 transition-colors rounded-none group shadow-sm" data-id="element-1361">
                    <div className="flex items-center gap-4 flex-1" data-id="element-1362">
                      <div className="flex-shrink-0" data-id="element-1363">
                        <UtensilsCrossed className="w-8 h-8 text-brand-pink" data-id="element-1364" />
                      </div>
                      <div className="flex-1" data-id="element-1365">
                        <div className="font-medium text-base mb-1" data-id="element-1366">
                          Breakfast Menu
                        </div>
                        <div className="text-sm text-neutral-500" data-id="element-1367">
                          Famous Bubbly Breakfast
                        </div>
                      </div>
                    </div>
                    <ChevronRight size={20} className="text-brand-pink group-hover:translate-x-1 transition-transform duration-200 flex-shrink-0" data-id="element-1368" />
                  </a>

                  <a href="#" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between gap-4 bg-white border-2 border-neutral-200 text-neutral-900 px-6 py-6 hover:border-brand-pink hover:bg-brand-pink/5 transition-colors rounded-none group shadow-sm" data-id="element-1369">
                    <div className="flex items-center gap-4 flex-1" data-id="element-1370">
                      <div className="flex-shrink-0" data-id="element-1371">
                        <UtensilsCrossed className="w-8 h-8 text-brand-pink" data-id="element-1372" />
                      </div>
                      <div className="flex-1" data-id="element-1373">
                        <div className="font-medium text-base mb-1" data-id="element-1374">
                          Breakfast Kids Menu
                        </div>
                        <div className="text-sm text-neutral-500" data-id="element-1375">
                          Delicious options for young guests
                        </div>
                      </div>
                    </div>
                    <ChevronRight size={20} className="text-brand-pink group-hover:translate-x-1 transition-transform duration-200 flex-shrink-0" data-id="element-1376" />
                  </a>
                </div>
              </div>

              {/* Lunch Group */}
              <div className="space-y-3" data-id="element-1377">
                <h3 className="text-sm font-medium text-neutral-500 uppercase tracking-wider mb-3" data-id="element-1378">
                  Lunch
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-1379">
                  <a href="#" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between gap-4 bg-white border-2 border-neutral-200 text-neutral-900 px-6 py-6 hover:border-brand-pink hover:bg-brand-pink/5 transition-colors rounded-none group shadow-sm" data-id="element-1380">
                    <div className="flex items-center gap-4 flex-1" data-id="element-1381">
                      <div className="flex-shrink-0" data-id="element-1382">
                        <UtensilsCrossed className="w-8 h-8 text-brand-pink" data-id="element-1383" />
                      </div>
                      <div className="flex-1" data-id="element-1384">
                        <div className="font-medium text-base mb-1" data-id="element-1385">
                          Lunch Menu
                        </div>
                        <div className="text-sm text-neutral-500" data-id="element-1386">
                          Leisurely lunch overlooking vineyards
                        </div>
                      </div>
                    </div>
                    <ChevronRight size={20} className="text-brand-pink group-hover:translate-x-1 transition-transform duration-200 flex-shrink-0" data-id="element-1387" />
                  </a>

                  <a href="#" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between gap-4 bg-white border-2 border-neutral-200 text-neutral-900 px-6 py-6 hover:border-brand-pink hover:bg-brand-pink/5 transition-colors rounded-none group shadow-sm" data-id="element-1388">
                    <div className="flex items-center gap-4 flex-1" data-id="element-1389">
                      <div className="flex-shrink-0" data-id="element-1390">
                        <UtensilsCrossed className="w-8 h-8 text-brand-pink" data-id="element-1391" />
                      </div>
                      <div className="flex-1" data-id="element-1392">
                        <div className="font-medium text-base mb-1" data-id="element-1393">
                          Lunch Kids Menu
                        </div>
                        <div className="text-sm text-neutral-500" data-id="element-1394">
                          Kid-friendly lunch for the family
                        </div>
                      </div>
                    </div>
                    <ChevronRight size={20} className="text-brand-pink group-hover:translate-x-1 transition-transform duration-200 flex-shrink-0" data-id="element-1395" />
                  </a>
                </div>
              </div>

              {/* Group Menus */}
              <div className="space-y-3" data-id="element-1396">
                <h3 className="text-sm font-medium text-neutral-500 uppercase tracking-wider mb-3" data-id="element-1397">
                  Group Dining
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-1398">
                  <a href="#" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between gap-4 bg-white border-2 border-neutral-200 text-neutral-900 px-6 py-6 hover:border-brand-pink hover:bg-brand-pink/5 transition-colors rounded-none group shadow-sm" data-id="element-1399">
                    <div className="flex items-center gap-4 flex-1" data-id="element-1400">
                      <div className="flex-shrink-0" data-id="element-1401">
                        <Users className="w-8 h-8 text-brand-pink" data-id="element-1402" />
                      </div>
                      <div className="flex-1" data-id="element-1403">
                        <div className="font-medium text-base mb-1" data-id="element-1404">
                          Group Breakfast Menu
                        </div>
                        <div className="text-sm text-neutral-500" data-id="element-1405">
                          Set menu for groups of 12-35 guests
                        </div>
                      </div>
                    </div>
                    <ChevronRight size={20} className="text-brand-pink group-hover:translate-x-1 transition-transform duration-200 flex-shrink-0" data-id="element-1406" />
                  </a>

                  <a href="#" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between gap-4 bg-white border-2 border-neutral-200 text-neutral-900 px-6 py-6 hover:border-brand-pink hover:bg-brand-pink/5 transition-colors rounded-none group shadow-sm" data-id="element-1407">
                    <div className="flex items-center gap-4 flex-1" data-id="element-1408">
                      <div className="flex-shrink-0" data-id="element-1409">
                        <Users className="w-8 h-8 text-brand-pink" data-id="element-1410" />
                      </div>
                      <div className="flex-1" data-id="element-1411">
                        <div className="font-medium text-base mb-1" data-id="element-1412">
                          Group Lunch Menu
                        </div>
                        <div className="text-sm text-neutral-500" data-id="element-1413">
                          Perfect for group celebrations
                        </div>
                      </div>
                    </div>
                    <ChevronRight size={20} className="text-brand-pink group-hover:translate-x-1 transition-transform duration-200 flex-shrink-0" data-id="element-1414" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Group Bookings Section - Split Hero Layout */}
      <section className="bg-neutral-100" data-id="element-1415">
        <div className="max-w-7xl mx-auto" data-id="element-1416">
          {/* Section Header - Full Width Above Split */}
          <div className="text-center py-16 px-8" data-id="element-1417">
            <div className="w-16 h-0.5 bg-brand-pink mx-auto mb-6" data-id="element-1418" />
            <div className="text-brand-pink text-xs tracking-[0.4em] font-light uppercase mb-4" data-id="element-1419">
              Events
            </div>
            <h2 className="font-heading text-5xl font-normal text-neutral-900 mb-6" data-id="element-1420">
              Celebrate in Style
            </h2>
            <p className="text-lg text-neutral-600 max-w-3xl mx-auto leading-relaxed" data-id="element-1421">
              Book the perfect place to celebrate with friends and family.
              Celebrate Birthdays, Bridal Showers, Hens Parties, Baby Showers &
              Corporate Events
            </p>
          </div>

          {/* Split Layout */}
          <div className="grid grid-cols-1 lg:grid-cols-5 min-h-[600px]" data-id="element-1422">
            {/* Left: Full-Height Image (40% width on desktop) */}
            <div className="lg:col-span-2 relative min-h-[400px] lg:min-h-full" data-id="element-1423">
              <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/11/restaurant-image-.jpg" alt="Group dining at Restaurant Cuvee" className="w-full h-full object-cover" data-id="element-1424" />
            </div>

            {/* Right: Content Stack (60% width on desktop) */}
            <div className="lg:col-span-3 bg-white p-8 lg:p-12 flex flex-col justify-center space-y-8" data-id="element-1425">
              {/* Heading */}
              <div data-id="element-1426">
                <h3 className="text-4xl lg:text-5xl font-serif text-gray-900 mb-4 leading-tight" data-id="element-1427">
                  Group Booking Information
                </h3>
                <p className="text-gray-600 text-lg leading-relaxed" data-id="element-1428">
                  Host a memorable celebration in the Hunter Valley for groups
                  of 12 to 35 guests.
                </p>
              </div>

              {/* Quick Facts Box */}
              <div className="border-2 border-neutral-200 p-6 space-y-4" data-id="element-1429">
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-1430">
                  <div className="flex items-start gap-3" data-id="element-1431">
                    <Users className="w-5 h-5 text-brand-pink mt-0.5 flex-shrink-0" data-id="element-1432" />
                    <div data-id="element-1433">
                      <p className="text-sm font-medium text-gray-900" data-id="element-1434">
                        Group Size
                      </p>
                      <p className="text-sm text-gray-600" data-id="element-1435">12-35 adults</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-1436">
                    <UtensilsCrossed className="w-5 h-5 text-brand-pink mt-0.5 flex-shrink-0" data-id="element-1437" />
                    <div data-id="element-1438">
                      <p className="text-sm font-medium text-gray-900" data-id="element-1439">Menu</p>
                      <p className="text-sm text-gray-600" data-id="element-1440">Set menu</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-1441">
                    <Wine className="w-5 h-5 text-brand-pink mt-0.5 flex-shrink-0" data-id="element-1442" />
                    <div data-id="element-1443">
                      <p className="text-sm font-medium text-gray-900" data-id="element-1444">
                        Alternate Drop
                      </p>
                      <p className="text-sm text-gray-600" data-id="element-1445">30+ guests</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Pricing Options */}
              <div data-id="element-1446">
                <h4 className="text-sm font-medium text-brand-pink tracking-[0.2em] uppercase mb-4" data-id="element-1447">
                  Set Menu Pricing Options
                </h4>
                <div className="space-y-3" data-id="element-1448">
                  <div className="flex items-center justify-between py-3 border-b border-neutral-200" data-id="element-1449">
                    <div className="flex items-center gap-3" data-id="element-1450">
                      <Check className="w-5 h-5 text-brand-pink flex-shrink-0" data-id="element-1451" />
                      <span className="text-gray-900 font-medium" data-id="element-1452">
                        Breakfast
                      </span>
                    </div>
                    <span className="text-2xl font-serif text-gray-900" data-id="element-1453">
                      $38.50
                      <span className="text-sm text-gray-500 font-sans" data-id="element-1454">
                        {' '}
                        pp
                      </span>
                    </span>
                  </div>
                  <div className="flex items-center justify-between py-3 border-b border-neutral-200" data-id="element-1455">
                    <div className="flex items-center gap-3" data-id="element-1456">
                      <Check className="w-5 h-5 text-brand-pink flex-shrink-0" data-id="element-1457" />
                      <span className="text-gray-900 font-medium" data-id="element-1458">
                        Lunch (Two Courses)
                      </span>
                    </div>
                    <span className="text-2xl font-serif text-gray-900" data-id="element-1459">
                      $76.00
                      <span className="text-sm text-gray-500 font-sans" data-id="element-1460">
                        {' '}
                        pp
                      </span>
                    </span>
                  </div>
                  <div className="flex items-center justify-between py-3 border-b border-neutral-200" data-id="element-1461">
                    <div className="flex items-center gap-3" data-id="element-1462">
                      <Check className="w-5 h-5 text-brand-pink flex-shrink-0" data-id="element-1463" />
                      <span className="text-gray-900 font-medium" data-id="element-1464">
                        Lunch (Three Courses)
                      </span>
                    </div>
                    <span className="text-2xl font-serif text-gray-900" data-id="element-1465">
                      $90.00
                      <span className="text-sm text-gray-500 font-sans" data-id="element-1466">
                        {' '}
                        pp
                      </span>
                    </span>
                  </div>
                  <p className="text-sm text-gray-500 pt-2" data-id="element-1467">
                    Kids' menu also available
                  </p>
                </div>
              </div>

              {/* Upgrade Experience Callout */}
              <div className="bg-brand-pink/10 border-l-4 border-brand-pink p-6" data-id="element-1468">
                <div className="flex items-start gap-3" data-id="element-1469">
                  <Wine className="w-6 h-6 text-brand-pink mt-1 flex-shrink-0" data-id="element-1470" />
                  <div data-id="element-1471">
                    <h4 className="text-xl font-serif text-gray-900 mb-2" data-id="element-1472">
                      Upgrade Your Experience
                    </h4>
                    <p className="text-gray-700 leading-relaxed mb-3" data-id="element-1473">
                      Add a Table Wine Tasting Experience – explore our
                      sparkling wines right at your table.
                    </p>
                    <p className="text-sm text-gray-600 font-medium" data-id="element-1474">
                      Enquire with the Cuvee team for details
                    </p>
                  </div>
                </div>
              </div>

              {/* CTA Button */}
              <div className="pt-4" data-id="element-1475">
                <button className="inline-flex items-center gap-2 bg-brand-pink text-white px-8 py-4 hover:bg-brand-pink/90 transition-colors font-medium rounded-none group w-full justify-center text-lg" data-id="element-1476">
                  <CalendarIcon size={20} data-id="element-1477" />
                  Book Your Group Event
                  <ChevronRight size={18} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-1478" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Booking Details & T&Cs Section */}
      <section className="bg-white py-20 px-8" data-id="element-1479">
        <div className="max-w-4xl mx-auto" data-id="element-1480">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-1481">
            {/* Booking Details */}
            <div className="space-y-6 flex flex-col" data-id="element-1482">
              <div className="space-y-3" data-id="element-1483">
                <div className="w-12 h-0.5 bg-brand-pink" data-id="element-1484"></div>
                <h3 className="text-3xl font-serif text-gray-900 leading-tight" data-id="element-1485">
                  Booking Details
                </h3>
              </div>
              <p className="text-gray-600 text-lg leading-relaxed" data-id="element-1486">
                Please contact our Restaurant Manager directly to arrange your
                group booking:
              </p>
              <div className="bg-neutral-100 p-6 rounded-none" data-id="element-1487">
                <p className="text-gray-900 font-medium mb-2" data-id="element-1488">
                  📧 Email Restaurant Manager
                </p>
                <a href="mailto:cuvee@petersonhouse.com.au" className="text-brand-pink hover:text-brand-pink/80 transition-colors" data-id="element-1489">
                  cuvee@petersonhouse.com.au
                </a>
              </div>
              <div className="mt-auto" data-id="element-1490">
                <button className="inline-flex items-center gap-2 bg-brand-pink text-white px-8 py-3 hover:bg-brand-pink/90 transition-colors font-medium rounded-none group w-full justify-center" data-id="element-1491">
                  <UtensilsCrossed size={18} data-id="element-1492" />
                  View Group Menus
                  <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-1493" />
                </button>
              </div>
            </div>

            {/* Terms & Conditions */}
            <div className="space-y-6" data-id="element-1494">
              <div className="space-y-3" data-id="element-1495">
                <div className="w-12 h-0.5 bg-brand-pink" data-id="element-1496"></div>
                <h3 className="text-3xl font-serif text-gray-900 leading-tight" data-id="element-1497">
                  T&C's
                </h3>
              </div>
              <div className="space-y-4" data-id="element-1498">
                <p className="text-gray-600 leading-relaxed" data-id="element-1499">
                  To secure your booking, we require a $20.00 per person
                  pre-authorisation holding fee.
                </p>
                <p className="text-gray-600 leading-relaxed" data-id="element-1500">
                  Cancellations must be received in writing at least 48 hours
                  prior to avoid charges.
                </p>
                <div className="bg-neutral-100 p-6 rounded-none space-y-2" data-id="element-1501">
                  <p className="text-gray-900 font-medium" data-id="element-1502">Please Note:</p>
                  <p className="text-gray-600 text-sm" data-id="element-1503">
                    • A 10% surcharge applies on Sundays
                  </p>
                  <p className="text-gray-600 text-sm" data-id="element-1504">
                    • A 15% surcharge applies on Public Holidays
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer data-id="element-1505" />
    </div>;
}